<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="1000px">
            <v-card>
                <v-card-title class="headline grey lighten-2" style="position: fixed;width: 1000px;z-index: 1;" primary-title>
                    <v-flex v-if="!View_Details">Upload result</v-flex>  
                    <v-flex v-else>View Result Details</v-flex>
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text style="padding-top:95px;">
                    <v-layout row v-if="!View_Details">
                        <v-select v-if="!AddCompany" item-value='_id' item-text='name' return-object v-model="SelectedCompany" :items="CompanyList" label="Select Company">
                            <template slot='selection' slot-scope='{ item }'>
                                {{ item.Company_Name }}
                            </template>
                            <template slot='item' slot-scope='{ item }'>
                                {{ item.Company_Name }}    
                            </template>
                        </v-select>
                        <v-flex v-else style="width: 85%;">
                            <v-text-field label="Company Name" v-model="Company_Name"></v-text-field>
                        </v-flex>
                        <v-btn icon v-if="!AddCompany" @click="AddCompany = true"> <v-icon>add</v-icon> </v-btn>
                        <v-flex v-else style="padding: 13px;">
                            <v-btn icon style="margin:0px;" @click="AddCompanyToDB"> <v-icon>library_add</v-icon> </v-btn>
                            <v-btn icon style="margin:0px;" @click="AddCompany = false"> <v-icon>cancel</v-icon> </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-layout v-else>
                        <v-flex style="font-size: 16px;font-weight: bold;"> Company : {{ SelectedCompany['Company_Name']}} </v-flex>
                    </v-layout>
                    <v-flex v-if="!View_Details">
                        <v-text-field label="Title" v-model="Title"></v-text-field>
                    </v-flex>
                    <v-flex v-else>
                        <v-flex style="font-size: 16px;font-weight: bold;">Title : {{ Title }}</v-flex>
                        <v-flex style="font-size: 16px;font-weight: bold;">URL : {{ `https://prwatech.com/result?query=${ SelectedCompany['Company_Name']}_${Title}_${Unique_Id}` }}</v-flex>
                    </v-flex>
                    <v-layout row style="text-align: center;" v-if="!View_Details">
                        <v-btn color="primary" @click="$refs.inputUpload.click()">Upload CSV File</v-btn>
                        <input v-show="false" type="file" id="csv_file" ref="inputUpload" name="csv_file" class="form-control" @change="loadCSV($event)">
                        <v-btn color="primary" @click="UploadData">Upload Data</v-btn>
                    </v-layout>
                    <v-data-table v-if="parse_header"
                                hide-actions
                                disable-initial-sort
                                :headers="parse_header"
                                :items="parse_csv"
                                item-key="Banner_Text"
                                class="elevation-1"
                                style="width:100%;margin-top:10px;">
                        <template v-slot:headers="props">
                            <tr>
                                <th v-for="header in props.headers" :key="header.text">{{ header.toUpperCase() }}</th>
                            </tr>
                        </template>
                        <template v-slot:items="props">
                            <tr>
                                <td class="text-xs-center" v-for="(item,index) in props.item" :key="item+'_'+index">{{ item }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>
export default {
     props: ['dialog'],
     data() {
        return {
            parse_header  : [],
            parse_csv     : [],
            sortOrders    : {},
            AddCompany    : false,
            SelectedCompany : {},
            CompanyList   : [],
            Company_Name  : "",
            Title         : "",
            View_Details  : false,
            Unique_Id     : 0,
        };
    },
  methods: {
    csvJSON(csv){

        let _this = this
        var lines = csv.split("\n")
        var result = []
        var headers = lines[0].split(",")
        this.parse_header = lines[0].split(",") 
        lines[0].split(",").forEach(function (key) {
            _this.sortOrders[key] = 1
        })
        
        lines.map(function(line, indexLine){
            if (indexLine < 1) return
            
            var obj = {}
            var currentline = line.split(",")
            
            headers.map(function(header, indexHeader){
            obj[header] = currentline[indexHeader]
            })
            
            result.push(obj)
        })
        result.pop()
      return result
    },
    loadCSV(e) {

      this.$eventHub.$emit("LOADING",true)
      if (window.FileReader) {
        var reader = new FileReader();
        reader.readAsText(e.target.files[0]);
        reader.onload = (event) => { var csv = event.target.result; this.parse_csv = this.csvJSON(csv); this.$eventHub.$emit("LOADING",false)};
        reader.onerror = (evt) => {
            evt.target.error.name == "NotReadableError" ? 
                  this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Cannot read file !", Color: "red", Close: false }) : "";
            this.$eventHub.$emit("LOADING",false)
        };
      } else {
       
        this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "FileReader are not supported in this browser.",Color: "red",Close: false });
        this.$eventHub.$emit("LOADING",false)
      }
    },
    UploadData(){
     
        let data = {
            Company_Id   : this.SelectedCompany['_id'],
            Company_Name : this.SelectedCompany['Company_Name'],
            User_List    : this.parse_csv,
            Title        : this.Title
        }
        this.$http.post(`${this.$store.getters.GetProductionUrl}/resultupload/createlist`,data)
                    .then(response =>{
                        
                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Uploaded Data","Color":"green","Close": false });
                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })
    },
    AddCompanyToDB(){

        this.$http.post(`${this.$store.getters.GetProductionUrl}/resultupload/addcompany`,{ "Company_Name": this.Company_Name})
                    .then(response =>{
                        
                        this.CompanyList.push(response['data']['response'])
                        this.AddCompany = false
                        this.Company_Name = ''
                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })
    },
    CloseDialog(){

        this.$emit('close')
    },
    FetchCompanyList(){
        
        this.$http.get(`${this.$store.getters.GetProductionUrl}/resultupload/getcompanylist`)
                    .then(response =>{
                        
                        this.CompanyList = response['data']['response']
                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })

    },
    DisplayDetails(data){

        this.SelectedCompany = { "_id" : data['Company_Id'] , "Company_Name": data['Company_Name']}
        this.View_Details = true
        this.Title = data['Title']
        this.parse_header = Object.keys(data['User_List'][0])
        this.parse_csv    = data['User_List']
        this.Unique_Id    = data['Unique_Id']
    }
  }
}
</script>
<style>

</style>